module.exports = __webpack_public_path__ + "static/media/Screenshot 2026-03-21 at 12.23.31.27a1ecf9.png";